/**
 * @hidden
 */
export var TIME_PART = {
    dayperiod: 'dayperiod',
    hour: 'hour',
    millisecond: 'millisecond',
    minute: 'minute',
    second: 'second'
};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dateinputs/dist/es/timepicker/models/time-part.default.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/timepicker/models/time-part.default.js
// module chunks = vendor